import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-verification-customer-card',
  templateUrl: './verification-customer-card.component.html',
  styleUrls: ['./verification-customer-card.component.scss']
})
export class VerificationCustomerCardComponent implements OnInit {

  @Input() cellPhone: string;
  @Input() firstName: string;
  @Input() lastName: string;
  @Input() requestDate: string;
  @Input() id: number;
  
  isMarketer: boolean =true;
  constructor(
    public router: Router 
  ) { }

  ngOnInit(): void {
  }

}
